module.exports = __webpack_public_path__ + "153c24011f621578aa51af7b6a2c8c58.svg";